import { useQuery, type QueryClient } from "@tanstack/react-query";

import { AgentRunStatus } from "@/src/models/agent-run";
import { getTaskAgentRun } from "@/src/requests/agent-run";

export const TASK_AGENT_RUN_CACHE_KEY = "task-agent-run";
export const TASK_AGENT_RUN_STALE_TIME_MS = 1000 * 30;
export const TASK_AGENT_RUN_POLL_INTERVAL_MS = 1000 * 5;

const ACTIVE_AGENT_RUN_STATUSES: AgentRunStatus[] = [
  AgentRunStatus.QUEUED,
  AgentRunStatus.PROCESSING,
  AgentRunStatus.MATERIALIZING,
];

// Whether the agent for this task is still actively running
export function isTaskAgentRunActive(queryClient: QueryClient, taskId: string): boolean {
  const data = queryClient.getQueryData<Awaited<ReturnType<typeof getTaskAgentRun>>>([
    TASK_AGENT_RUN_CACHE_KEY,
    taskId,
  ]);
  const status = data?.agentRun?.status;

  return Boolean(status && ACTIVE_AGENT_RUN_STATUSES.includes(status));
}

export function useTaskAgentRun(taskId: string) {
  return useQuery({
    queryKey: [TASK_AGENT_RUN_CACHE_KEY, taskId],
    queryFn: () => getTaskAgentRun(taskId),
    staleTime: TASK_AGENT_RUN_STALE_TIME_MS,
    refetchInterval: (query) => {
      const status = query.state.data?.agentRun?.status;

      return status && ACTIVE_AGENT_RUN_STATUSES.includes(status) ? TASK_AGENT_RUN_POLL_INTERVAL_MS : false;
    },
  });
}
